var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close_svg__a",
    d: "M0 0h37v37H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "close_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "close_svg__a",
    d: "M0 0h19.566v19.567H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".close_svg__a{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(1.5 1.5)",
    fill: "#eee",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5 8.5)",
    clipPath: "url(#close_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "transparent",
    stroke: "transparent"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h19.566v19.567H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "close_svg__a",
    d: "M.5.5h18.566v18.567H.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.269 3.729a1.013 1.013 0 000-1.432 1.013 1.013 0 00-1.432 0L9.783 8.352 3.728 2.297a1.012 1.012 0 00-1.432 0 1.013 1.013 0 000 1.432l6.055 6.054-6.055 6.055a1.013 1.013 0 000 1.432 1.009 1.009 0 00.716.3 1.009 1.009 0 00.716-.3l6.055-6.055 6.054 6.054a1.009 1.009 0 00.716.3 1.009 1.009 0 00.716-.3 1.012 1.012 0 000-1.431l-6.054-6.055z",
    fill: "#a3a3a3"
  })))));
}
export var url = __webpack_public_path__ + "38d1a46efcdc4badd453b4d76a969c3f.svg";
;
export default SvgClose;